if (
  document.readyState === 'complete' 
  || document.readyState === 'loaded' 
  || document.readyState === 'interactive'
) {
  //DOM is already ready.
  loadScripts();
} else {
  //Set event listener to wait for DOM.
  document.addEventListener('DOMContentLoaded', loadScripts);
}

function loadScripts() {
  //Load JS dependencies: add to the array with a loadScript('INSERT external JS file URL') for each dependency. The init script will only run once all dependencies are ready.
  Promise.all(
    [
      loadScript('https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js')
    ]
  ).then(
    function(scripts) {
      init();
    }
  )
}

function init() {
  //Start your async JS here.
  var sliders = document.querySelectorAll('[data-sitebuilder-swiper]');
  sliders.forEach(
    function(item) {
      var id = item.dataset.sitebuilderSwiper;
      var config = window.sitebuilderSwiperConfig[id].config;
      if(window.sitebuilderSwiperConfig[id].initiated == false) {
        const swiper = new Swiper(`[data-sitebuilder-swiper='${id}']`,config);
        window.sitebuilderSwiperConfig[id].initiated = true;
        window.sitebuilderSwiperConfig[id].instance = swiper;
        if(typeof window.sitebuilderSwiperConfig[id].onInit == 'function') {
          window.sitebuilderSwiperConfig[id].onInit(swiper);
        }
      }
    }
  );
  if(!window.sitebuilderSwiperInit) {
    window.sitebuilderSwiperInit = init;
  }
}

//Helpers

function loadScript(src, async = true, type = 'text/javascript') {
  return new Promise((resolve, reject) => {
    try {
      const el = document.createElement('script');
      const container = document.head || document.body;

      el.type = type;
      el.async = async;
      el.src = src;

      el.addEventListener('load', () => {
          resolve({ status: true });
      });

      el.addEventListener('error', () => {
          reject({
              status: false,
              message: `Failed to load the script src`
          });
      });

      container.appendChild(el);
  } catch (err) {
      reject(err);
  }
  });
};